/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetApMerchantIdAssociationRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {SetApMerchantIdAssociationResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const setApMerchantIdAssociation = (request: SetApMerchantIdAssociationRequest, options?: CashRequestOptions) => post<SetApMerchantIdAssociationRequest, SetApMerchantIdAssociationResponse>("/2.0/cash/set-ap-merchant-id-association", request, {...options, rejectOnError: true })